var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / circle-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.862 30.9311C8.69195 30.9311 2.06885 24.308 2.06885 16.138C2.06885 7.96795 8.69195 1.34485 16.862 1.34485C25.032 1.34485 31.6551 7.96795 31.6551 16.138C31.6551 24.308 25.032 30.9311 16.862 30.9311ZM16.862 28.2414C23.5465 28.2414 28.9654 22.8225 28.9654 16.138C28.9654 9.4534 23.5465 4.0345 16.862 4.0345C10.1774 4.0345 4.7585 9.4534 4.7585 16.138C4.7585 22.8225 10.1774 28.2414 16.862 28.2414ZM12.4336 22.4682L16.862 18.0398L21.2903 22.4682L23.1922 20.5663L18.7638 16.138L23.1922 11.7096L21.2903 9.80771L16.862 14.2361L12.4336 9.80771L10.5317 11.7096L14.9601 16.138L10.5317 20.5663L12.4336 22.4682Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.20804ae1d811e9167b5a759f318c57ff.svg";
export { ForwardRef as ReactComponent };